import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import axios from 'axios'
import Antd from 'ant-design-vue';
import 'ant-design-vue/dist/antd.css';
import VueDirectiveImagePreviewer from 'vue-directive-image-previewer'
import 'vue-directive-image-previewer/dist/assets/style.css'
Vue.use(Antd);
Vue.config.productionTip = false
Vue.use(VueDirectiveImagePreviewer, {
  zIndex: 9999, //层级显示
  previewSize: 15, //15倍图
})
// router.beforeEach((to, from, next) => {
//   console.log(to.path);
//   if (to.path !== "/login" ) {
//       var token = sessionStorage.getItem("accessToken");
//       if (token === null || token === undefined) {
//           next('/login')
//       } else {
//           next();
//       }
//   } else {
//       next();
//   }
// })

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount('#app')
